import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";

dayjs.extend(utc);

export const formatRelativeTime = (isoString: string): string => {
  const localDateTime = dayjs.utc(isoString).local();
  const now = dayjs();

  const diffSeconds = now.diff(localDateTime, "second");
  const diffMinutes = now.diff(localDateTime, "minute");
  const diffHours = now.diff(localDateTime, "hour");

  if (diffSeconds < 60) return "Just now";
  if (diffMinutes < 60) return `${diffMinutes} minute${diffMinutes === 1 ? "" : "s"} ago`;
  if (diffHours < 24) return `${diffHours} hour${diffHours === 1 ? "" : "s"} ago`;

  return localDateTime.format("MM/DD/YYYY");
};
